import React from 'react'
import PropTypes from 'prop-types'
import NextHead from 'next/head'
import {
  defaultTitle,
  defaultOGImage,
  nonPartisanOGImage,
  partisanTitle,
  partisanDescription,
  nonPartisanTitle,
  nonPartisanDescription,
  defaultOGURL,
  v1OGImage,
  shareOGImage,
  googleSearchConsoleTags
} from '../constants/HeadInformation'

const gtmScript =
  process.env.NODE_ENV !== 'development'
    ? {
      __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-M98N8MC');
            `,
    }
    : { __html: `` }

const segScript =
  process.env.NODE_ENV !== 'dev'
    ? {
      __html: `
      !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.13.1";
      analytics.load("esDICEljuUmDAP6PjZGgZNYaIM2oJ4hg");
      analytics.page();
      }}();
`,
    }
    : { __html: `` }

const webpSupport = {
  __html: `
      !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
`,
}


const Head = ({ url, title, description, nonPartisan, share, v1 }) => {
  let ogTitle = nonPartisan ? nonPartisanTitle : partisanTitle
  let ogDescription = nonPartisan ? nonPartisanDescription : partisanDescription
  let ogImg = nonPartisan ? nonPartisanOGImage : defaultOGImage
  let ogURL = nonPartisan ? `${defaultOGURL}/vote` : defaultOGURL
  if (share) {
    ogURL = `${defaultOGURL}/2020`
    ogTitle = "Some votes are NOT counted until after election day."
    ogDescription = "Get the best voting options for your state."
    ogImg = shareOGImage
  }
  if (v1) {
    ogURL = `${defaultOGURL}/v1`
    ogImg = v1OGImage
    ogTitle = "Landslide 2020"
    ogDescription = "Start a Landslide to crush Trump and the GOP. Track your impact. Multiply your power."
  }

  return (<NextHead>
    <meta charSet="UTF-8" />
    <title>{title || defaultTitle} </title>
    <meta name="description" content={description || ogDescription} />
    {/* <meta name="viewport" content="width=device-width, initial-scale=1" /> */}
    {/* INFO: should prevent iPhone from zooming in on input fields */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0" />
    <link rel="icon" sizes="192x192" href="/static/touch-icon.png" />
    <link rel="apple-touch-icon" href="/static/touch-icon.png" />
    <link rel="mask-icon" href="/static/favicon-mask.svg" color="#ff696d" />

    <link rel="icon" href="/static/favicon.ico" />

    <meta name="google-site-verification" content="o8FHKiidYYQht2B1rwKr2OT8skZYc8Lkknyi-yG92V0" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@thresholdmvmt" />
    <meta name="twitter:title" content={ogTitle} />
    <meta name="twitter:description" content={ogDescription} />
    <meta name="twitter:image" content={ogImg} />

    <meta property="og:url" content={ogURL} />
    <meta property="og:title" content={ogTitle} />
    <meta property="og:type" content="website" />
    <meta property="og:image" content={ogImg} />
    <meta property="og:description" content={ogDescription} />
    <meta property="fb:app_id" content="1531051710526317" />
    {/* google search console tag, valid only landslide2020.org */}
    <meta name="google-site-verification" content={googleSearchConsoleTags} />
    <meta name="fo-verify" content="9b31673d-0ff7-4e1f-ab22-717dee176126"></meta>
    <script dangerouslySetInnerHTML={gtmScript} />
    <script dangerouslySetInnerHTML={segScript} />
    <script dangerouslySetInnerHTML={webpSupport} />
    {/* <script src="https://www.googleoptimize.com/optimize.js?id=OPT-K2J72LD"></script> */}
    <script src="https://www.googleoptimize.com/optimize.js?id=OPT-P7NN6LF"></script>
  </NextHead>)
}

Head.defaultProps = {
  nonPartisan: false,
  share: false,
  v1: false
}

Head.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  ogImage: PropTypes.string,
  twitterImage: PropTypes.string,
  nonPartisan: PropTypes.bool,
  share: PropTypes.bool,
  v1: PropTypes.bool,
}

export default Head
